import React from 'react';
import { styled } from '@mui/material/styles';
import {Box, Grid, Link} from '@material-ui/core';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {MetaTags} from 'react-meta-tags';
import axios from 'axios';
import {API_URL} from '../utils/EnvVars';
import { makeStyles } from '@material-ui/core/styles';
import Header from "./HeaderMy";
import LeftDrawer from "../components/LeftDrawer";
import '../styles/bizofficer-a.css';

const useStyles = makeStyles((theme) => ({
	content: {
	  [theme.breakpoints.up('md')]: {
		marginLeft:240,
		marginTop:60,
	  },
	  padding: theme.spacing(1),
	},
  }));

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
	height: 10,
	borderRadius: 5,
	[`&.${linearProgressClasses.colorPrimary}`]: {
	  backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
	},
	[`& .${linearProgressClasses.bar}`]: {
	  borderRadius: 5,
	  backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
	},
  }));  
  

  export default function Execute() {
	const classes = useStyles();
	// check if logged in
	if(localStorage.getItem('etlStudentObj')===null){
		window.location.href='login';
	}
	var etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));
	const [pageLoading, setPageLoading] = React.useState(true);
	const [myData, setMyData] = React.useState([]);
	const [backButtonShow, setBackButtonShow] = React.useState(0);
	const [parentTopicsDetails, setParentTopicsDetails] = React.useState([]);
	const [topicsDetails, setTopicsDetails] = React.useState([]);
	const [chartOneData, setChartOneData] = React.useState({credits: false,chart:{type: 'pie',height: 325},title:{text: ''},subtitle: {text: ''},caption: {text: ''},tooltip: {valueSuffix: ' %'},plotOptions : {pie: {allowPointSelect: true,cursor: 'pointer',dataLabels: {distance:-30,style: {fontSize: '12px',textOutline: 0},enabled: true,format: '{point.y}%'}}},series: [{showInLegend: true,name: '',data: []}]});
	const [chartTwoData, setChartTwoData] = React.useState({credits: false,chart: {type: 'column',height: 325},title: {text: ''},caption: {text: ''},tooltip: {valueSuffix: ' '},xAxis: {categories: [],},yAxis: {title: {text: ''},},plotOptions:{column: {	threshold: 0, dataLabels: {enabled: true,formatter: function() {return this.y < 0 ? -(this.y) + ' ' : this.y + ' '}}}},series: [{showInLegend: false,name: 'Marks',title:null, data: []}]});
	const [chartThreeData, setChartThreeData] = React.useState({credits: false,chart:{type: 'pie',height: 325},title:{text: 'Time'},subtitle: {text: ''},caption: {text: ''},tooltip: {valueSuffix: ' %'},plotOptions : {pie: {allowPointSelect: true,cursor: 'pointer',dataLabels: {distance:-30,style: {fontSize: '12px',textOutline: 0},enabled: true,format: '{point.y}%'}}},series: [{showInLegend: true,name: '',data: []}]});
	const [chartFourData, setChartFourData] = React.useState({credits: false,chart: {type: 'column',height: 230},title: {text: ''},caption: {text: ''},tooltip: {valueSuffix: ' %'},xAxis: {categories: [],},yAxis: {title: {text: ''},},plotOptions:{column: {	threshold: 0, dataLabels: {enabled: true,formatter: function() {return this.y < 0 ? -(this.y) + ' %' : this.y + ' %'}}}},series: [{showInLegend: false,name: 'Score',title:null, data: []}]});
	const [chartFiveData, setChartFiveData] = React.useState({credits: false,chart: {type: 'column',height: 325},title: {text: 'Average Time'},caption: {text: ''},tooltip: {formatter: function () { var time = this.y; var hours=Math.floor(time/3600); if(hours<10){hours='0'+hours;} var mins=Math.floor(time % 3600 / 60); if(mins<10){mins='0'+mins;} var secs=Math.floor(time % 3600 % 60); if(secs<10){secs='0'+secs;} return this.x+" "+hours+':'+mins+':'+secs; }},xAxis: {categories: [],},yAxis: {title: {text: ''},},plotOptions:{column: {	threshold: 0, dataLabels: {enabled: true,formatter: function () { var time = this.y; var hours=Math.floor(time/3600); if(hours<10){hours='0'+hours;} var mins=Math.floor(time % 3600 / 60); if(mins<10){mins='0'+mins;} var secs=Math.floor(time % 3600 % 60); if(secs<10){secs='0'+secs;} return hours+':'+mins+':'+secs; }}}},series: [{showInLegend: false,name: '',title:null, data: []}]});

	const [chartCompareTopics, setChartCompareTopics] = React.useState({credits: false,chart: {type: 'column',height: 325},title: {text: ''},caption: {text: ''},tooltip: {valueSuffix: ' '},xAxis: {categories: [],},yAxis: {title: {text: ''},},plotOptions:{column: {	threshold: 0, dataLabels: {enabled: true,formatter: function() {return this.y < 0 ? -(this.y) + ' ' : this.y + ' '}}}},series: [{showInLegend: false,name: 'Marks',title:null, data: []}]});
	const [chartBenchMarks, setChartBenchMarks] = React.useState({credits: false,chart: {type: 'column',height: 280},title: {text: ''},caption: {text: ''},tooltip: {valueSuffix: ' '},xAxis: {categories: [],},yAxis: {title: {text: ''},},plotOptions:{column: {	threshold: 0, dataLabels: {enabled: true,formatter: function() {return this.y < 0 ? -(this.y) + ' ' : this.y + ' '}}}},series: [{showInLegend: false,name: 'Score',title:null, data: []}]});

	const [progressBar, setProgressBar] = React.useState(0);
	const [progressBarFlag, setProgressBarFlag] = React.useState(0);
	const [progressBarColor, setProgressBarColor] = React.useState('red');
	const [progressBarRemarks, setProgressBarRemarks] = React.useState('');

	const authResult = new URLSearchParams(window.location.search); 
	const testId = authResult.get('testId');
	const [value, setValue] = React.useState('1');

	const deviceType = authResult.get('device_type');
  	if(deviceType && deviceType.length>0){
    	localStorage.setItem("deviceType", deviceType);
  	}
	
	function getParent(){
		if(parentTopicsDetails && parentTopicsDetails.length>1){
			setBackButtonShow(1);
			setTopicsDetails(parentTopicsDetails[parentTopicsDetails.length-1]);
			setParentTopicsDetails(parentTopicsDetails => [parentTopicsDetails.splice(parentTopicsDetails.length-1, 1)]);	
		}else{
			setParentTopicsDetails([]);
			setBackButtonShow(0);
			setTopicsDetails(myData.sectionSet);
		}	
	}
	function getChildren(backObj,nextObj){
		if(nextObj!=null){
			setBackButtonShow(1);
			setParentTopicsDetails(parentTopicsDetails => [...parentTopicsDetails, backObj]);
			setTopicsDetails(nextObj);				
		}
	}	

	const handleChange = (event, newValue) => { //taboneboxid
	  if(newValue==1){
		document.getElementById('taboneboxid').style.display="";
		document.getElementById('tabtwoboxid').style.display="none";
		document.getElementById('tabthreeboxid').style.display="none";
		document.getElementById('tabfourboxid').style.display="none";
	  }else if(newValue==2){
		document.getElementById('taboneboxid').style.display="none";
		document.getElementById('tabtwoboxid').style.display="";
		document.getElementById('tabthreeboxid').style.display="none";
		document.getElementById('tabfourboxid').style.display="none";
	  }else if(newValue==3){
		document.getElementById('taboneboxid').style.display="none";
		document.getElementById('tabtwoboxid').style.display="none";
		document.getElementById('tabthreeboxid').style.display="";
		document.getElementById('tabfourboxid').style.display="none";
	  }else if(newValue==4){
		document.getElementById('taboneboxid').style.display="none";
		document.getElementById('tabtwoboxid').style.display="none";
		document.getElementById('tabthreeboxid').style.display="none";
		document.getElementById('tabfourboxid').style.display="";
	  }else if(newValue==5){		
		window.location.href="testview?testId=mt"+testId;
		return false;
	  }	
	  setValue(newValue);
	};

	React.useEffect(() => {	
		setValue('1');	
		getApiData();
	}, []); 

	async function getApiData(){
		let axiosHeader = {
			headers:{
				'Content-Type': 'multipart/mixed',
				'loginId': etlStudentObj.loginId,
				'token': etlStudentObj.token,
				'device': 'web'
			}
		};
		axios.get(API_URL+'/analytics?testSession='+testId, axiosHeader)
		   .then(response => {
			setPageLoading(false);
			if(response && response.status===200 && response.data){

				//document.writeln(JSON.stringify(response.data));
				setMyData(response.data);	

				if(response.data.progressBarObj && response.data.progressBarObj.percentage){
					setProgressBar(response.data.progressBarObj.percentage);	
					setProgressBarFlag(1);		
					setProgressBarColor(response.data.progressBarObj.barColor);
					setProgressBarRemarks('');
					if(response.data.progressBarObj.barColor==='green'){
						setProgressBarRemarks('Well done. Move to competitive mode');
					}else if(response.data.progressBarObj.barColor==='orange'){
						setProgressBarRemarks('Good progress but still continue learning');
					}else{
						setProgressBarRemarks('Not upto mark. Continue learning');
					}
				}

				setTopicsDetails(response.data.sectionSet);

				setChartOneData({ series: [{ data: response.data.overallPerformanceList }] });
				setChartTwoData({ xAxis: [{ categories: response.data.sectionList }] }); 
				setChartTwoData({ series: response.data.sectionPerformanceList }); 
				setChartThreeData({ series: [{ data: [{y: response.data.timeTakenPercent, name: "Time Taken", color: "#4198d7"}, {y: response.data.timeRemainingPercent, name: "Time Remaining", color: "#e55759" }] }] });
				
				if(response.data && response.data.topperCompare && response.data.topperCompare[0] && response.data.topperCompare[1] && response.data.topperCompare[0].scorePercentage){
					setChartFourData({ xAxis: [{ categories: ['You',response.data.topperCompare[0].title,'Avg'] }] }); 
					setChartFourData({ series: [{data: [{"y": response.data.percentageMarks, "color": "#574fc5"},{"y": response.data.topperCompare[0].scorePercentage,"color": "#29bf28"},{"y": response.data.topperCompare[1].scorePercentage,"color": "#f04951"}]}] }); 
				}

				setChartFiveData({ xAxis: [{ categories: ['Available time','Time taken on attempted questions'] }] }); 
				setChartFiveData({ series: [{data: [{"y": response.data.totalTimeSeconds, "color": "#574fc5"},{"y": response.data.timeSpent,"color": "#29bf28"}]}] }); 

				if(response.data.topicList && response.data.topicList.length>0){
					setChartCompareTopics({ xAxis: [{ categories: response.data.topicList }] }); 
					setChartCompareTopics({ series: response.data.topperTopicMarksList }); 
				}

				if(response.data && response.data.marksObtain && response.data.minBenchMarks>0 && response.data.maxBenchMarks>0){
					setChartBenchMarks({ xAxis: [{ categories: ['You','Min Benchmarks','Max Benchmarks'] }] }); 
					setChartBenchMarks({ series: [{data: [{"y": response.data.marksObtain, "color": "#574fc5"},{"y": response.data.minBenchMarks,"color": "#29bf28"},{"y": response.data.maxBenchMarks,"color": "#f04951"}]}] }); 
				}

			} else if (response && response.data && response.data.responseTxt === "invalidToken") {
				window.localStorage.removeItem("etlStudentObj");
				window.localStorage.clear();
				window.location.href = 'logout';				

			}

	   })

	}

	const ProgressBarGraph = styled(LinearProgress)(({ theme }) => ({
		height: 10,
		borderRadius: 5,
		[`&.${linearProgressClasses.colorPrimary}`]: {
		  backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
		},
		[`& .${linearProgressClasses.bar}`]: {
		  borderRadius: 5,
		  backgroundColor: theme.palette.mode === 'light' ? progressBarColor : '#308fe8',
		},
	  }));

	return (
		<div> 
				<MetaTags>
            		<title>Analytics</title>
          		</MetaTags>
				
				<Header />	
				<LeftDrawer />
				<main className={classes.content}>
				
				{pageLoading?<LinearProgress />:null}

			{myData?	
				<Box style={{marginBottom:150, marginLeft:20, marginRight:20}}>	

					<Box mt={1}>
							<Grid container spacing={2}>
								<Grid item md={12} xs={12}>
									<h3 className="heading" >{myData.testName}</h3>
									<h4 style={{color:'#f50057'}}>{myData.submitDate?<span>Date:{myData.submitDate}</span>:null}</h4>
								</Grid>
							</Grid>
					</Box>

					<Box mt={1} className='anylyticbox' >
							<Grid container spacing={2}>
								<Grid item md={12} xs={12}>
									<h2>Dear {myData.studentName}, You got <i>{myData.rank}</i> rank among <i>{myData.totalStudent}</i> Students</h2>
								</Grid>

								<Grid item md={4} sm={12} xs={12} className='lrpadding' >
									<Grid container spacing={2}>
										<Grid item md={6} sm={6} xs={6} >
											<h4>MARKS SCORED</h4>
										</Grid>
										<Grid item md={6} sm={6} xs={6} className='rightalign' >
											<h3>{myData.marksObtain}/{myData.fullMarks}</h3>
										</Grid>	
									</Grid>
									<BorderLinearProgress variant="determinate" value={myData.percentageMarks} />
									<h3>{myData.percentageMarks}%</h3>
								</Grid>

								<Grid item md={4} sm={12} xs={12} className='lrpadding' >
									<Grid container spacing={2}>
										<Grid item md={6} sm={6} xs={6} >
											<h4>PERCENTILE</h4>
										</Grid>
										<Grid item md={6} sm={6} xs={6} className='rightalign' >
											<h3>{myData.percentile}%</h3>
										</Grid>	
									</Grid>
									<BorderLinearProgress variant="determinate" value={myData.percentile} />
									<h3>{myData.percentile}%</h3>
								</Grid>
								
								<Grid item md={4} sm={12} xs={12} className='lrpadding' >
									<Grid container spacing={2}>
										<Grid item md={8} sm={8} xs={8} >
											<h4>TIME SPENT (Min)</h4>
										</Grid>
										<Grid item md={4} sm={4} xs={4} className='rightalign' >
											<h3>{myData.timeSpentMinutes}/{myData.totalTime}</h3>
										</Grid>	
									</Grid>
									<BorderLinearProgress variant="determinate" value={myData.percentageTime} />
									<h3>{myData.percentageTime?<>{myData.percentageTime}</>:<>0</>}%</h3>
								</Grid>

							</Grid>
					</Box>
					
					<Box mt={1} sx={{ width: '100%', typography: 'body1' }}>
						<TabContext value={value}>
							<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
							<TabList onChange={handleChange} centered variant="scrollable" scrollButtons="auto" aria-label="lab API tabs example">
								<Tab label="Overall Performance" value="1" />
								<Tab label="View Answers" value="5" />
								<Tab label="Performance in Detail" value="2" />
								<Tab label="Time Management" value="3" />
								<Tab label="Comparative Study" value="4" />								
							</TabList>
							</Box>
							<TabPanel value="1"></TabPanel>
							<TabPanel value="2"></TabPanel>
							<TabPanel value="3"></TabPanel>
							<TabPanel value="4"></TabPanel>
						</TabContext>						
					</Box>

					
					{/********************  Overall Performance ****************************/}
					<Box id="taboneboxid" style={{marginTop:-30}} >

						{(progressBarFlag && progressBarFlag>0)?						
							<Box style={{marginBottom:20}} >
								<Grid container spacing={2}>
									<Grid item xs={12} style={{textAlign:'center'}} ><h3>Progress Bar</h3></Grid>
								</Grid>
								<Grid container spacing={2}>
									<Grid item md={4} sm={4} xs={12} ></Grid>
									<Grid item md={4} sm={4} xs={12} >
										<h1 style={{textAlign:'center', color:progressBarColor}}>{progressBar}%</h1>
										<ProgressBarGraph variant="determinate" value={progressBar} />
										{progressBarRemarks?<div style={{textAlign:'center'}}>{progressBarRemarks}</div>:null}
									</Grid>
									<Grid item md={4} sm={4} xs={12} ></Grid>
								</Grid>
							</Box>
						:null}

						<Grid container spacing={2}>												
									<Grid item md={4} xs={12} >
										{pageLoading?
											<Stack spacing={1}>
												<Skeleton variant="circular" width={200} height={200} />
											</Stack>
											:
											<HighchartsReact
												highcharts={Highcharts}
												options={chartOneData}
											/>
										}
									</Grid>
									<Grid item md={8} xs={12} >
										{pageLoading?
											<Stack spacing={1}>
												<Skeleton variant="text" width={'98%'} />
												<Skeleton variant="text" width={'98%'} />
												<Skeleton variant="text" width={'98%'} />
												<Skeleton variant="text" width={'98%'} />
												<Skeleton variant="text" width={'98%'} />
											</Stack>
											:	
											<HighchartsReact
												highcharts={Highcharts}
												options={chartTwoData}
											/>
  										}	
									</Grid>
						</Grid>


					</Box>

					{/********************  Performance in Detail ****************************/}
					<Box id="tabtwoboxid" style={{display:'none',marginTop:-30}} >						
						{pageLoading?
									<Stack spacing={1}>
										<Skeleton variant="text" width={'98%'} />
										<Skeleton variant="text" width={'98%'} />
										<Skeleton variant="text" width={'98%'} />
										<Skeleton variant="text" width={'98%'} />
										<Skeleton variant="text" width={'98%'} />
									</Stack>
								:<>
						<h4 style={{color:'#1572e8'}}>Drill Down Your Performance</h4>
						<TableContainer component={Paper}>						
						<Table sx={{ minWidth: 650 }} aria-label="simple table">
							<TableHead>
							<TableRow style={{backgroundColor:'#aad7f7'}}>
								<TableCell style={{fontWeight:'bold',width:150}} >
									{backButtonShow?<><Link href="javascript:;" onClick={()=>{getParent()}} style={{color:'#fe3000'}} >Back</Link> Topic Name</>:<>Section Name</>}									
								</TableCell>
								<TableCell style={{fontWeight:'bold'}} align="center">Full Marks</TableCell>
								<TableCell style={{fontWeight:'bold'}} align="center">Marks Obtained</TableCell>
								<TableCell style={{fontWeight:'bold',width:400}} align="center">Percentage</TableCell>
								<TableCell style={{fontWeight:'bold'}} align="center"></TableCell>
							</TableRow>
							</TableHead>							
							<TableBody>
							{topicsDetails?topicsDetails.map((myRow,index) => (
								<TableRow	
								key={'tbr'+index}							
								sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
								>
								<TableCell style={{backgroundColor:'#edf6fc'}} >
									{(myRow.children!=null && myRow.children[0]!=null)?<Link href="javascript:;" onClick={()=>{getChildren(topicsDetails, myRow.children)}} >{myRow.sectionName}</Link>:myRow.sectionName}
								</TableCell>
								<TableCell align="center" style={{fontWeight:'bold'}}>{myRow.sectionTotalScore}</TableCell>
								<TableCell align="center" style={{fontWeight:'bold'}}>{myRow.sectionScore} </TableCell>
								<TableCell align="center">
									<table width={'100%'}>
										<tr>
											<td>&nbsp;{myRow.percentage<0?<div style={{fontSize:9,fontWeight:'bold',backgroundColor:'#ff3c4e',padding:6,width:-myRow.percentage+'%',height:15,marginLeft:'auto',marginRight:'55%'}} ></div>:null}</td>
											<td>&nbsp;{myRow.percentage>0?<div style={{fontSize:9,fontWeight:'bold',backgroundColor:'#4be64b',padding:6,width:myRow.percentage+'%',height:15}} ></div>:null}</td>
										</tr>	
									</table>
								</TableCell>
								<TableCell align="center" style={{fontWeight:'bold'}}>{(myRow.percentage!=null && myRow.percentage>0)?<span style={{color:'#0000FF'}}>{myRow.percentage}%</span>:<span style={{color:'#FF0000'}}>{myRow.percentage}%</span>}</TableCell>
								</TableRow>
							)):null} 
							</TableBody>
						</Table>
						</TableContainer>
						<br/>
						<TableContainer component={Paper}>						
						<Table sx={{ minWidth: 650 }} aria-label="simple table">
							<TableHead>
							<TableRow style={{backgroundColor:'#aad7f7'}}>
								<TableCell style={{fontWeight:'bold',width:150}} >
									{backButtonShow?<>Topic Name</>:<>Section Name</>}									
								</TableCell>
								<TableCell style={{fontWeight:'bold'}} align="center">Correct Questions</TableCell>
								<TableCell style={{fontWeight:'bold'}} align="center">Incorrect Questions</TableCell>
								<TableCell style={{fontWeight:'bold'}} align="center">Un-attempted Questions</TableCell>
								<TableCell style={{fontWeight:'bold'}} align="center">Total</TableCell>
								<TableCell style={{fontWeight:'bold',width:400}} align="center">Percentage</TableCell>

							</TableRow>
							</TableHead>
							<TableBody>
							{topicsDetails?topicsDetails.map((myRow,index) => (
								<TableRow	
								key={'tbr'+index}							
								sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
								>
								<TableCell style={{backgroundColor:'#edf6fc'}} >
									{myRow.sectionName}
								</TableCell>
								<TableCell align="center" style={{color:'#12a812',fontWeight:'bold'}} >{myRow.correctQuestions}</TableCell>
								<TableCell align="center" style={{color:'#ff3c4e',fontWeight:'bold'}} >{myRow.incorrectQuestions}</TableCell>
								<TableCell align="center" style={{color:'#9e3ef2',fontWeight:'bold'}} >{myRow.unattemptedQuestions}</TableCell>
								<TableCell align="center" style={{fontWeight:'bold'}}>{myRow.totalQuestion}</TableCell>
								<TableCell align="center">
									<table width={'100%'}>
										<tr>
											<td style={{fontSize:9,fontWeight:'bold',backgroundColor:'#4be64b',padding:6,width:myRow.correctQuestionsPercentage+'%',height:15}}>&nbsp;{myRow.correctQuestionsPercentage}%</td>
											<td style={{fontSize:9,fontWeight:'bold',backgroundColor:'#ff3c4e',padding:6,width:myRow.incorrectQuestionsPercentage+'%',height:15}}>&nbsp;{myRow.incorrectQuestionsPercentage}%</td>
											<td style={{fontSize:9,fontWeight:'bold',backgroundColor:'#c693f2',padding:6,width:myRow.unattemptedQuestionsPercentage+'%',height:15}}>&nbsp;{myRow.unattemptedQuestionsPercentage}%</td>
										</tr>	
									</table>
								</TableCell>

								</TableRow>
							)):null} 
							</TableBody>
						</Table>
						</TableContainer>

						</>
  						}		
					</Box>

					{/********************  Time Management ****************************/}
					<Box id="tabthreeboxid" style={{display:'none',marginTop:-30}} >
						<Grid container spacing={2} style={{justifyContent:'center',marginTop:40}} >
							<Grid item md={4} xs={12}  >
								{pageLoading?
											<Stack spacing={1}>
												<Skeleton variant="circular" width={200} height={200} />
											</Stack>
											:
								<HighchartsReact
									highcharts={Highcharts}
									options={chartThreeData}
								/>
  								}
							</Grid>
							<Grid item md={4} xs={12}  >
								{pageLoading?
											<Stack spacing={1}>
												<Skeleton variant="circular" width={200} height={200} />
											</Stack>
											:
								<HighchartsReact
									highcharts={Highcharts}
									options={chartFiveData}
								/>
  								}
							</Grid>
							<Grid item md={4} xs={12}  >
								{pageLoading?
									<Stack spacing={1}>
										<Skeleton variant="text" width={'98%'} />
										<Skeleton variant="text" width={'98%'} />
										<Skeleton variant="text" width={'98%'} />
										<Skeleton variant="text" width={'98%'} />
										<Skeleton variant="text" width={'98%'} />
									</Stack>
								:
								<TableContainer component={Paper}>
									<Table aria-label="simple table">
										<TableBody>										
											<TableRow>
												<TableCell >Total Time</TableCell>
												<TableCell >{myData.totalTimeLabel}</TableCell>
											</TableRow>
											<TableRow>
												<TableCell >Time Taken</TableCell>
												<TableCell >{myData.spentTimeLabel}</TableCell>
											</TableRow>
											<TableRow>
												<TableCell >Remaining Time</TableCell>
												<TableCell >{myData.remainingTimeLabel}</TableCell>
											</TableRow>
											<TableRow>
												<TableCell >Avg. Speed per Question</TableCell>
												<TableCell >{myData.averageSpeedPerQuestionLabel}</TableCell>
											</TableRow>
										</TableBody>
									</Table>
								</TableContainer>
  								}
							</Grid>
						</Grid>	
					</Box>

					{/********************  Compare with Topper ****************************/}
					<Box mt={1} id="tabfourboxid" style={{display:'none',marginTop:-30}} >
						{pageLoading?
									<Stack spacing={1}>
										<Skeleton variant="text" width={'98%'} />
										<Skeleton variant="text" width={'98%'} />
										<Skeleton variant="text" width={'98%'} />
										<Skeleton variant="text" width={'98%'} />
										<Skeleton variant="text" width={'98%'} />
									</Stack>
						:<>
						<h3 style={{marginBottom:15}}>Compare with topper</h3>
						<Grid container spacing={2}>																			
							<Grid item md={8} sm={12} xs={12} >
								<TableContainer component={Paper}>
								<Table sx={{ minWidth: 650 }} aria-label="simple table">
									<TableHead>
									<TableRow>
										<TableCell className='tblcelltop'></TableCell>
										<TableCell className='tblcelltop' >Score</TableCell>
										<TableCell className='tblcelltop' >Correct Questions</TableCell>
										<TableCell className='tblcelltop' >Incorrect Questions</TableCell>
										<TableCell className='tblcelltop' >Un-attempted Questions</TableCell>
										<TableCell className='tblcelltop' >Time Spent (Minutes)</TableCell>
									</TableRow>
									</TableHead>
									<TableBody>
										<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
											<TableCell className='tblcelltopyou' component="th" scope="row" >You</TableCell>
											<TableCell className='tblcelltopyou' >{myData.marksObtain}/{myData.fullMarks}</TableCell>
											<TableCell className='tblcelltopyou' >{myData.correctAnswers}/{myData.totalQuestion}</TableCell>
											<TableCell className='tblcelltopyou' >{myData.incorrectAnswers}/{myData.totalQuestion}</TableCell>
											<TableCell className='tblcelltopyou' >{myData.notAnswers}/{myData.totalQuestion}</TableCell>
											<TableCell className='tblcelltopyou' >{myData.timeSpentMinutes}</TableCell>
										</TableRow>
										{(myData.topperCompare && myData.topperCompare[0])? 
										<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
											<TableCell className='tblcelltopper' component="th" scope="row" >{myData.topperCompare[0].title}</TableCell>
											<TableCell className='tblcelltopper' >{myData.topperCompare[0].score}/{myData.fullMarks}</TableCell>
											<TableCell className='tblcelltopper' >{myData.topperCompare[0].correctQuestions}/{myData.totalQuestion}</TableCell>
											<TableCell className='tblcelltopper' >{myData.topperCompare[0].incorrectQuestions}/{myData.totalQuestion}</TableCell>
											<TableCell className='tblcelltopper' >{myData.totalQuestion-(myData.topperCompare[0].correctQuestions+myData.topperCompare[0].incorrectQuestions)}/{myData.totalQuestion}</TableCell>
											<TableCell className='tblcelltopper' >{myData.topperCompare[0].timeSpent}</TableCell>
										</TableRow>
  										:null}
										{(myData.topperCompare && myData.topperCompare[1])?  
										<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
											<TableCell className='tblcelltopavg' component="th" scope="row" >Avg</TableCell>
											<TableCell className='tblcelltopavg' >{myData.topperCompare[1].score}/{myData.fullMarks}</TableCell>
											<TableCell className='tblcelltopavg' >{myData.topperCompare[1].correctQuestions}/{myData.totalQuestion}</TableCell>
											<TableCell className='tblcelltopavg' >{myData.topperCompare[1].incorrectQuestions}/{myData.totalQuestion}</TableCell>
											<TableCell className='tblcelltopavg' >{myData.totalQuestion-(myData.topperCompare[1].correctQuestions+myData.topperCompare[1].incorrectQuestions)}/{myData.totalQuestion}</TableCell>
											<TableCell className='tblcelltopavg' >{myData.topperCompare[1].timeSpent}</TableCell>
										</TableRow>
										:null}
									</TableBody>
								</Table>
								</TableContainer>
							</Grid>
							<Grid item md={4} sm={12} xs={12} >
								<HighchartsReact
									highcharts={Highcharts}
									options={chartFourData}
								/>
							</Grid>
						</Grid>					
						
						<Grid container spacing={2}>					
							<Grid item md={8} sm={12} xs={12} >
								<h3 style={{marginBottom:15}}>Topic wise comparison</h3>
								<TableContainer component={Paper} style={{boxShadow: "none"}} >
									<Table sx={{ minWidth: 650 }} aria-label="simple table">
										<TableBody>
											<TableRow>
												<HighchartsReact
													highcharts={Highcharts}
													options={chartCompareTopics}
												/>
											</TableRow>
										</TableBody>
									</Table>	
								</TableContainer>
							</Grid>
							{(myData && myData.minBenchMarks>0 && myData.maxBenchMarks>0)?<>
							<Grid item md={4} sm={12} xs={12} >
								<h3 style={{marginBottom:15}}>Benchmarks comparison</h3>
								<HighchartsReact
									highcharts={Highcharts}
									options={chartBenchMarks}
								/>
							</Grid>
							</>:null}
						</Grid>

						
						</>}
					</Box>


				</Box>
			:null}
			</main>
		</div>	
	);
  }